import type {Location, Point} from '../../types/location';

function isPoint(value: unknown): value is {
    lat: number;
    lon: number;
} {
    return (
        (value as Point).lat != null && Number.isFinite((value as Point).lat) && (value as Point).lon != null && Number.isFinite((value as Point).lon)
    );
}

export function getSearchURL(sanitizedQuery: URLSearchParams, selectedLocation: Location | null, sourceComponent?: string): string {
    const searchParams = sanitizedQuery;

    if (selectedLocation) {
        for (const [key, value] of Object.entries(selectedLocation)) {
            if (value != null) {
                if (key === 'formattedAddress' && typeof value === 'string') {
                    searchParams.set('location', value);
                } else if (key === 'loc' && isPoint(value)) {
                    searchParams.set('lat', value.lat.toString());
                    searchParams.set('lon', value.lon.toString());
                } else if (typeof value === 'string' || typeof value === 'boolean') {
                    searchParams.set(key, value.toString());
                }
            }
        }
    }

    if (sourceComponent) {
        searchParams.set('sourceComponent', sourceComponent);
    }

    return `/s?${searchParams.toString()}`;
}
